interface CableConfig {
  url: string
}

// Global config
export let cableConfig: CableConfig | null = null

export const configureCable = (config: CableConfig): void => {
  cableConfig = config
}
